import React, { ReactElement, ReactNode, useEffect, useState, useCallback } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import { useAuth } from '@clerk/clerk-react';
import { fetchCompanies, selectAllCompanies } from '../../slices/companies/companiesSlice';
import { useAppSelector } from '../hooks/useAppSelector';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import { useAppDispatch } from '../hooks/useAppDispatch';
import { sanitizeRedirectUrl } from '../helpers/sanitize';

export const NoCompanyRedirect = ({
  children,
}: {
  children?: ReactNode | undefined;
}): ReactElement => {
  const { isSignedIn } = useAuth();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const companyInstance = useAppSelector(selectAllCompanies)[0];
  const path = location.pathname;

  const getCompany = useCallback(() => {
    if (isSignedIn) {
      if (companyInstance) {
        setLoading(false);
      } else {
        dispatch(fetchCompanies())
          .unwrap()
          .finally(() => setLoading(false));
      }
    }
  }, [isSignedIn, companyInstance, dispatch]);

  useEffect(() => {
    getCompany();
  }, [getCompany]);

  if (loading) {
    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 'calc(100vh - 104px)',
        }}
      >
        <CircularProgress color='primary' size={50} />
      </Box>
    );
  }

  if (!companyInstance && isSignedIn) {
    return (
      <Navigate
        to={`${ROUTES.COMPANY_CREATE}?backUrl=${encodeURIComponent(sanitizeRedirectUrl(path))}`}
        replace
      />
    );
  }
  return <>{children}</>;
};
